// extracted by mini-css-extract-plugin
export var active = "_au-7";
export var container = "_au-0";
export var evenWidth = "_au-4";
export var large = "_au-5";
export var outlet = "_au-8";
export var slide = "_au-2";
export var small = "_au-6";
export var tab = "_au-3";
export var tabs = "_au-1";